import { getAgreeableClient } from './agreeable/agreeable-client';

export const agreeable = getAgreeableClient();
export const agreeableStateStore = agreeable.state;
